import React, { Component } from 'react'
import { Tooltip, Switch } from 'antd'
import { QuestionCircleTwoTone } from '@ant-design/icons'
import './index.css'

export default class index extends Component {
  render() {
    const { key, title, toolTip, value, disabled, special } = this.props.item
    return (
      <div className="text-tip-switch-view">
        <div className="tts-left-class">
          <span
            className={`title-switch-class ${
              disabled ? 'disabled-switch-title-color' : ''
            } ${special ? 'switch-special-class' : ''}`}
          >
            {title}
          </span>
          {toolTip.length > 0 && (
            <Tooltip
              trigger="hover"
              placement="right"
              arrowPointAtCenter
              title={toolTip}
            >
              <QuestionCircleTwoTone
                style={{ marginLeft: '10px', fontSize: '18px' }}
              />
            </Tooltip>
          )}
        </div>
        <div className="tts-right-class">
          <Switch
            disabled={disabled}
            checked={value}
            onChange={this.props.onSwitchChange}
          ></Switch>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/textTipSwitchView/index.js